import React from 'react';
import ProgramTabsSection from './ProgramTabsSection';
import AgenticAiHero from '../agentic-ia/AgenticAiHero';

const ProgramDetailsPage = () => {
	return (
		<>
			<AgenticAiHero />
			<ProgramTabsSection />
		</>
	);
};

export default ProgramDetailsPage;
